import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PurchaseOrder } from "../../OrderMFE/Orders/types/purchaseOrder";

export interface PurchaseOrderState {
  purchaseOrderList: PurchaseOrder[];
  purchaseOrderDetail?: PurchaseOrder;
}

const initialState: PurchaseOrderState = {
  purchaseOrderList: [],
  purchaseOrderDetail: undefined
};

export const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {
    setPurchaseOrderList: (state, action: PayloadAction<PurchaseOrder[]>) => {
      state.purchaseOrderList = action.payload;
    },
    setPurchaseOrderDetail: (state, action: PayloadAction<PurchaseOrder>) => {
      state.purchaseOrderDetail = action.payload;
    },
    resetPurchaseOrderDetail: (state) => {
      state.purchaseOrderDetail = undefined;
    }
  }
});

export const {
  setPurchaseOrderList,
  setPurchaseOrderDetail,
  resetPurchaseOrderDetail
} = purchaseOrderSlice.actions;

export default purchaseOrderSlice.reducer;
